import React, { useEffect } from "react";
import { FormControl, Grid, InputLabel, MenuItem, Select } from "@material-ui/core";

export function OpcoesGrupo(props) {
    const {
        grupos,
        escolhaGrupo,
        handleChangeGrupos,
    } = props;
    
    return (
        <Grid container>
            <Grid item xs={6}>
                <FormControl fullWidth>
                    <InputLabel id="label-grupos">Grupos</InputLabel>
                    <Select
                        labelId="label-grupos"
                        id="select-grupos"
                        label="Grupos"
                        value={escolhaGrupo}
                        onChange={handleChangeGrupos}
                    >
                        {grupos.map((grupo, index) => (
                            <MenuItem
                                key={index}
                                value={index}
                            >
                                {grupo.nm_grupo}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
}
